import { AuthContext } from '@/contexts/AuthContext.tsx';
import { useContext, useMemo } from 'react';

export const Heading = () => {
  const { firebaseUser } = useContext(AuthContext);

  const firstName = useMemo(
    () => firebaseUser?.displayName?.split(' ')[0],
    [firebaseUser],
  );

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div className="mb-5">
        {firebaseUser?.photoURL ? (
          <img
            className="size-10 rounded-full"
            src={firebaseUser?.photoURL}
            alt=""
          />
        ) : (
          <div className="size-10 rounded-full bg-gray-100" />
        )}
      </div>
      <h2 className="text-base-900 mb-3 text-2xl leading-[1.2] font-medium -tracking-[0.01em] sm:text-[32px]">
        Welcome{firstName ? `, ${firstName}` : ''}
      </h2>
      <p className={'font-inter text-[14px]/[1.4] tracking-[0.01em]'}>
        To get started, please choose the workspace you want to work in
      </p>
    </div>
  );
};
